import { Global } from '@emotion/react'
import { style } from '@mui/system'
import styles from '../config/styles.json'
import "suneditor/dist/css/suneditor.min.css"

const AppGlobalStyles = ({ theme }) => (
  <Global
    styles={{
      a: { textDecoration: 'none' },
      '.mt-0': { marginTop: 0 },
      '.mt-1': { marginTop: theme.spacing(1) },
      '.mt-2': { marginTop: theme.spacing(2) },
      '.mt-3': { marginTop: theme.spacing(3) },
      '.mt-4': { marginTop: theme.spacing(4) },
      '.mt-5': { marginTop: theme.spacing(5) },
      '.mt-6': { marginTop: theme.spacing(6) },
      '.mt-7': { marginTop: theme.spacing(7) },
      '.mt-8': { marginTop: theme.spacing(8) },
      '.mt-9': { marginTop: theme.spacing(9) },
      '.mt-10': { marginTop: theme.spacing(10) },

      '.mb-0': { marginBottom: 0 },
      '.mb-1': { marginBottom: theme.spacing(1) },
      '.mb-2': { marginBottom: theme.spacing(2) },
      '.mb-3': { marginBottom: theme.spacing(3) },
      '.mb-4': { marginBottom: theme.spacing(4) },
      '.mb-5': { marginBottom: theme.spacing(5) },
      '.mb-6': { marginBottom: theme.spacing(6) },
      '.mb-7': { marginBottom: theme.spacing(7) },
      '.mb-8': { marginBottom: theme.spacing(8) },
      '.mb-9': { marginBottom: theme.spacing(9) },
      '.mb-10': { marginBottom: theme.spacing(10) },

      '.ml-0': { marginLeft: 0 },
      '.ml-1': { marginLeft: theme.spacing(1) },
      '.ml-2': { marginLeft: theme.spacing(2) },
      '.ml-3': { marginLeft: theme.spacing(3) },
      '.ml-4': { marginLeft: theme.spacing(4) },
      '.ml-5': { marginLeft: theme.spacing(5) },
      '.ml-6': { marginLeft: theme.spacing(6) },
      '.ml-7': { marginLeft: theme.spacing(7) },
      '.ml-8': { marginLeft: theme.spacing(8) },
      '.ml-9': { marginLeft: theme.spacing(9) },
      '.ml-10': { marginLeft: theme.spacing(10) },

      '.mr-0': { marginRight: 0 },
      '.mr-1': { marginRight: theme.spacing(1) },
      '.mr-2': { marginRight: theme.spacing(2) },
      '.mr-3': { marginRight: theme.spacing(3) },
      '.mr-4': { marginRight: theme.spacing(4) },
      '.mr-5': { marginRight: theme.spacing(5) },
      '.mr-6': { marginRight: theme.spacing(6) },
      '.mr-7': { marginRight: theme.spacing(7) },
      '.mr-8': { marginRight: theme.spacing(8) },
      '.mr-9': { marginRight: theme.spacing(9) },
      '.mr-10': { marginRight: theme.spacing(10) },

      '.pb-0': { paddingBottom: 0 },
      '.pb-1': { paddingBottom: theme.spacing(1) },
      '.pb-2': { paddingBottom: theme.spacing(2) },
      '.pb-3': { paddingBottom: theme.spacing(3) },
      '.pb-4': { paddingBottom: theme.spacing(4) },
      '.pb-5': { paddingBottom: theme.spacing(5) },
      '.pb-6': { paddingBottom: theme.spacing(6) },
      '.pb-7': { paddingBottom: theme.spacing(7) },
      '.pb-8': { paddingBottom: theme.spacing(8) },
      '.pb-9': { paddingBottom: theme.spacing(9) },
      '.pb-10': { paddingBottom: theme.spacing(10) },

      '.pt-0': { paddingTop: 0 },
      '.pt-1': { paddingTop: theme.spacing(1) },
      '.pt-2': { paddingTop: theme.spacing(2) },
      '.pt-3': { paddingTop: theme.spacing(3) },
      '.pt-4': { paddingTop: theme.spacing(4) },
      '.pt-5': { paddingTop: theme.spacing(5) },
      '.pt-6': { paddingTop: theme.spacing(6) },
      '.pt-7': { paddingTop: theme.spacing(7) },
      '.pt-8': { paddingTop: theme.spacing(8) },
      '.pt-9': { paddingTop: theme.spacing(9) },
      '.pt-10': { paddingTop: theme.spacing(10) },

      '.t-medium': { fontWeight: '500' },
      '.t-semibold': { fontWeight: '600' },
      '.t-bold': { fontWeight: 'bold' },
      body: {
        margin: 0,
        padding: 0,
        backgroundColor: styles.body.background,
        color: styles.body.color,
        fontFamily: styles.body.fontFamily,

        '& main div': {
          maxWidth: '100%'
        }
      },
      '.app_layout': {
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1,
        minHeight: '100vh',
        //backgroundColor: theme.palette.primary.main,
        position: 'relative',
      },
      '.app_layout_frame': {
        display: 'flex',
        flexDirection: 'column',
        //overflowX: 'scroll',
      },
      '.content': {
        display: 'flex',
        maxWidth: '100% !important',
        flexDirection: 'column',
        flexGrow: 1,
        marginTop: '50px',
        /* padding: theme.spacing(4), */
        //overflow: 'hidden'
      },
      '.paper_content': {
        width: '100%',
        overflowX: 'auto',
        /* padding: theme.spacing(2), */
      },
      '.app_page_header': {
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1,
        position: 'relative',
        //backgroundColor: theme.palette.primary[50],
        backgroundColor: 'white',
        padding: theme.spacing(3),
      },
      '.card-header-title': {
        fontSize: '1em',
        //textTransform: 'uppercase',
        fontWeight: 600,
      },
      '.app_page_header_content': {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 2,
        /* padding: theme.spacing(3), */
      },
      '.app_header': {
        flexGrow: 1,
      },
      '.appBarUser': {
        padding: 5,
      },
      '#menu-appbar': {
        '& .MuiListItemIcon-root': {
          minWidth: 36
        },

        "& .MuiListItemText-root": {
          color: '#00000099'
        }
      },
      '.headerAppBar': {
        padding: 0,
        '.headerMainButton': {
          padding: 20,
          paddingLeft: 30,
          paddingRight: 30,
        },
        '.MuiButtonBase-root': {
          color: 'white',
          border: 'none',
          fontSize: 13,
        },
        '.Mui-selected': {
          color: 'white !important',
          border: 'none',
          backgroundColor: 'rgba(0, 0, 0, 0.2) !important',
        },
        '.moduleMenuToggle': {
          '& .subItem': {
            paddingLeft: 30,
          },
          div: {
            paddingLeft: 10,
            paddingRight: 10,
          },
        },
      },
      '.cardCrudBottomButtons': {
        display: 'flex',
        flexGrow: 1,
        backgroundColor: '#fff',
        padding: 10,
        '& .leftSide': {
          flexGrow: 1,
        },
        '& .rightSide': {
          flexGrow: 1,
          justifyContent: 'flex-end',
          display: 'flex',
        },
        '& .button': {
          marginRight: 10,
        },
      },

      '.sidebarNavigation': {
        '& .subItem': {
          paddingLeft: 30,
        },
      },
      '.bottomHeaderPanel': {
        display: 'flex',
        fontSize: '1em',
        backgroundColor: 'white',
        padding: 8,
        justifyContent: 'flex-end',
        '& .buttonsBloq': {
          display: 'flex',
          alignItems: 'center',
          '& .MuiButton-root': {
            marginLeft: 10,
          },
        },
        '& .leftBloq': {
          flexGrow: 1,
        },
        '& .rightBloq': {
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'flex-end',
        },
        '& .headerTitle': {
          fontSize: 32,
          fontWeight: 600,
        },
      },
      '.MuiToolbar-regular, .RaToolbar-desktopToolbar, .MuiToolbar-root': {
        background: 'none !important',
        marginBottom: '10px',
      },
      '.crudCardContainer': {
        '& .MuiPaper-root': {
          background: 'none',
        },
      },
      '.CrudShowContainer': {
        '& .MuiCardContent-root': {
          padding: 25,
        },
        '& p': {
          color: styles.body.color,
          fontSize: styles.body.fontSize,
          fontFamily: styles.body.fontFamily,
          paddingTop: 10,
          paddingBottom: 10,
        },
      },
      '.CrudListContainer': {},
      '.CrudEditContainer': {},
      '.uiShowListElement': {
        padding: 16,
        '& .keyText': {
          color: styles.body.color,
          fontWeight: 600,
        },
        '& .valueText': {
          marginLeft: 5,
        },
        '& .MuiChip-root': {
          marginRight: 5,
          borderColor: '#5663c9d1',
        },
      },
      '.editInputsWrap': {
        padding: '0 15px',
        fontSize: 14,
        minHeight: 120,
        "&.small": {
          minHeight: 0
        },
        '&.input-gray': {
          '& .MuiOutlinedInput-notchedOutline': {
            backgroundColor: '#0000000d',
          },
        },
        '& .labelBloq': {
          display: 'flex',
          alignItems: 'baseline',
          marginBottom: 10,
          '& .label': {
            fontSize: styles.body.fontSize,
            fontWeight: 600,

            '&:not(.Mui-disabled)': {
              color: styles.body.color,
            },
          },
          '& .tooltip': {
            fontSize: 14,
            marginLeft: 10,
            color: '#5663c9d1',
            cursor: 'pointer',
          },
        },
        '& legend': {
          display: 'none',
        },
        '& .MuiFormControl-root': {
          padding: 0,
          margin: 0,
        },
      },
      '.payment-register .editInputsWrap': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center', /* Alineación vertical */
        fontSize: '16px',
        minHeight: '110px',
      },
      '.payment-register-payment .editInputsWrap': {
        minHeight: '100px',
      },
      '.image-input': {
        '& .RaLabeled-label': {
          display: "none"
        }
      },
      '.hiddenElement': {
        visibility: 'hidden',
      },
      '.RaBulkActionsToolbar-toolbar': {
        top: -45,
      },
      '&.formRelatedFields': {
        backgroundColor: '#26b1f10a',
        border: '1px solid #26b1f145',
        borderRadius: 3,
        padding: 15,
        flexGrow: 1,
      },
      '.genericTransferCard': {
        border: '1px solid',
        borderColor: 'rgba(0, 0, 0, 0.23)',
        boxShadow: 'none',
        flexGrow: 1,
        '&.MuiPaper-root': {
          boxShadow: 'none',
        },

        '& .MuiCardHeader-root': {
          padding: 10,
          '& .headerTitle': {
            fontSize: 15,
            fontWeight: 100,
          },
        },
        '& .MuiCardContent-root': {
          height: 500,
          flexGrow: 1,
          overflow: 'auto',
          '& .MuiCheckbox-root': {
            padding: '0px',
          },
          '& .MuiTreeItem-root.assigned': {
            '& .MuiTreeItem-content': {
              '& .MuiTypography-root': {
                fontWeight: 600,
                color: '#673ab7',
              },
            },
          },
          '& .MuiTreeItem-content.Mui-focused': {
            background: 'none',
          },
          '& .deselected ': {
            background: 'none',
            '& .Mui-selected': {
              '&.MuiListItemButton-root, &.MuiTreeItem-content': {
                border: 'none',
                background: 'none',
              },
              '& .MuiTypography-root': {
                fontWeight: 500,
                color: 'inherit',
              },
            },
          },
          '& .Mui-selected': {
            '&.MuiListItemButton-root, &.MuiTreeItem-content': {
              border: '1px solid #ff9800',
              borderRadius: 3,
              backgroundColor: 'rgb(255 193 7 / 8%)',
            },
            '& .MuiTypography-root': {
              fontWeight: 600,
              color: '#673ab7',
            },
          },
          '& .MuiListItemIcon-root': {
            padding: 0,
            minWidth: 'inherit',
            marginRight: 15,
          },
          '& .MuiTreeItem-content': {
            padding: 10,
            '&.Mui-selected': {
              padding: 10,
              '& .MuiTreeItem-label': {
                fontWeight: 600,
              },
            },
          },
        },
        '& .MuiList-root': {
          '& .cardList': {
            width: '100 %',
            height: 400,
            bgcolor: 'background.paper',
            overflow: 'auto',
            '& .MuiListItem-root': {
              padding: 0,
            },
          },
        },
      },
      '& .FormDivider.MuiGrid-root': {
        marginTop: 15,
        marginBottom: 35,

        '& .MuiDivider-root': {
          "&.dashed": {
            "&::before, &::after": {
              borderTopStyle: "dashed"
            }
          }
        },
      },
      '.transferListComponent': {
        display: 'flex',
        '& .transferListCard': {
          border: '1px solid',
          borderColor: 'rgba(0, 0, 0, 0.23)',
          boxShadow: 'none',
          flexGrow: 1,
          '& .cardList': {
            width: '100 %',
            height: 400,
            bgcolor: 'background.paper',
            overflow: 'auto',
            '& .MuiListItem-root': {
              padding: 0,
            },
          },
        },
      },
      '.addItemSeparator': {
        borderBottom: '3px solid',
        borderColor: styles.colors.primary,
        marginBottom: 15,
        '& .MuiGrid-root': {
          justifyContent: 'flex-end',
          display: 'flex',
          paddingBottom: 10,
        },
        '& .MuiButton-root': {
          justifyContent: 'flex-end',
        },
      },
      '.uiCardCommon': {
        '&.MuiCardHeader-root': {
          padding: '10px 15px',
        },
        '&.MuiPaper-root': {
          backgroundColor: 'white',
        },
        '& .cardActions': {
          padding: 15,
          justifyContent: 'flex-end',
        },
      },
      '.uiCardCommonExpandible': {
        boxShadow: 'none !important',
        borderRadius: '4px !important',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        marginTop: '0px !important',

        '&:before': {
          display: 'none',
        },

        '& .MuiAccordionSummary-root': {
          padding: 16,
          backgroundColor: '#f6f7ff',

          '& .MuiAccordionSummary-content': {
            margin: 0,
          },

          '& .MuiTypography-root': {
            color: '#505155',
            fontSize: '1.3333em',
            fontWeight: 500,
            lineHeight: 1.6,
          },
        },

        '& .MuiAccordionDetails-root': {
          padding: 16,
        },
      },
      '.productNavigationActions': {
        display: 'flex',
        padding: 15,
        '& .backButton': {
          top: -5,
          right: -10,
        },
        '& .prodNavLeftBloq': {},
        '& .prodNavRightBloq': {
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center ',
          '& .MuiButton-root': {
            marginLeft: 15,
          },
        },
        '& .MuiButton-root': {
          height: 40,
        },
        '& .breadcrumbLinks': {
          marginLeft: 50,
        },
      },
      '.navigationTabsPanel': {
        '& .MuiTabs-root': {
          backgroundColor: styles.header.navigation_panel_background,
          marginBottom: 0,
        },
        '& .hidden': {
          visibility: 'hidden',
        },
        '& .subMenuItem': {
          fontSize: 16,
          fontWeight: 600,
          padding: 15,
          alignItems: 'center',
        },
      },
      '.breadcrumbComponent': {
        fontSize: '1em',
      },
      '.breadcrumb_link': {
        display: 'flex',
        alignItems: 'center',
        fontSize: '1em',
      },
      '.breadcrumb_icon': {
        //marginRight: theme.spacing(0.5),
        marginRight: 4,
        fontSize: '1em',
      },
      '.card_with_icon': {
        marginRight: 10,
        '& .icon': {
          color: theme.palette.primary.main,
          marginRight: 8,
        },
        '& .content': {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
      '.MuiTableCell-head': {
        '& .MuiButtonBase-root': {
          fontFamily: styles.body.fontFamilySecondary,
          fontSize: styles.table_cell.head_fontSize,
        },
        '& span': {
          fontFamily: styles.body.fontFamilySecondary,
          fontSize: styles.table_cell.head_fontSize,
        },
      },
      '.MuiTableCell-body': {
        '& .MuiTypography-root': {
          fontFamily: styles.body.fontFamilySecondary,
          fontSize: styles.table_cell.body_fontSize,
        },
      },
      '.tabbed_show_layout': {
        '& .MuiDivider-root': {
          display: 'none',
        },
      },
      '.MuiTab-textColorInherit.Mui-selected': {
        color: theme.palette.primary.main,
      },
      '.RaLoginForm-button-57': {
        backgroundColor: theme.palette.primary.main,
      },
      '.menu-container': {
        position: 'relative',
        '&.menu': {},
        '& .submenu': {
          top: 20,
        },
      },
      '.dialog-actions': {
        justifyContent: 'space-between !important',
      },
      '.form-helper-text': {
        margin: '4px 14px 0 !important',
      },
      '.css-vacdnp-RaFilterForm-root': {
        alignItems: 'center !important',
      },
      '.filter-field': {
        alignItems: 'center !important',
        marginRight: '5px',
      },
      '.filter-field .hide-filter': {
        margin: '0 5px 0 0 !important',
      },
      '.datePicker': {
        width: '100%',
        minWidth: '170px !important',

        '& input': {
          padding: '8.5px 0px 8.5px 14px',
        },
      },
      '.list_item_button': {
        padding: '0px 16px !important',

        '& .list_item_checkbox': {
          padding: '0 0 0 12px',
        },
      },
      '.chip-input': {
        '.MuiOutlinedInput-notchedOutline': {
          top: '-3px !important',
          bottom: '-3px !important',
        },
      },
      '.select-checkbox': {
        padding: '0 9px 0 0 !important',
      },
      '.operator-icon': {
        width: '1.5em',
        height: '1.5em',
        fill: 'currentcolor',
        stroke: 'currentcolor',
      },
      '.select': {
        display: 'flex',

        '&-switch': {
          display: 'flex',
          alignItems: 'center',
          maxHeight: '40px',
          minWidth: '95px',
        },

        '&-include': {
          width: 'calc(100% - 95px) !important',
        },
      },
      '.json-mapper': {
        '.button': {
          marginRight: 10,
        },
      },
      '.loading-indicator': {
        display: 'flex',
        alignItems: 'center',
      },
      '.currency_resume': {
        backgroundColor: '#bcf3bc',
        border: '1px solid green',
        borderRadius: '10px',
        width: 'fit-content',
        padding: '5px',
        float: 'right',
      },
      '.subtotals_resume': {
        float: 'right',
        marginRight: '20px',

        '.subtotal_item': {
          display: 'flex',
          marginBottom: '10px',
        },

        '.subtotal_title': {
          marginRight: '20px',

          padding: '2px 4px',
          minWidth: '120px',
          textAlign: 'center',
        },

        '.button': {
          margin: '10px 0',
          float: 'right',
        },
      },
      '.subtotals_resume_payment_method': {
        width: '100%',
        display: 'flex',
        marginRight: '20px',
        justifyContent: 'left',
        alignItems: 'flex-end',
        flexDirection: 'column',
        '.subtotals_resume_payment_method_container': {
          minwidth: '250px',
          width: 'auto',
          height: 'auto',
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
          justifyContent: 'center',
        },
        '.subtotal_item': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '10px',
        },

        '.subtotal_title': {
          marginRight: '20px',
          border: '1px solid lightgrey',
          borderRadius: '5px',
          padding: '2px 4px',
          minWidth: '120px',
          textAlign: 'center',
        },
        '.total_title': {
          marginRight: '20px',
          padding: '2px 4px',
          minWidth: '120px',
          textAlign: 'center',
        },
        '.total_value': {
          color: '#2cf562',
        },
        '.button': {
          margin: '10px 0',
          float: 'right',
        },
      },
      '.checkbox_table': {
        width: '24px',
        padding: '0 12px 0 16px !important',

        '.MuiCheckbox-root': {
          padding: '0 !important',
        },
      },
      '.input_table': {
        input: {
          padding: '1px 8px !important',
        },
        '.MuiSelect-select': {
          padding: '2px 32px 2px 10px !important',
        },
      },
      '.payment_entity_container': {
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '.payment_entity_container_row': {
        width: '100%',
        height: 'auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      '.payment_entity_container_row_button': {
        width: 'auto',
        height: '120px',
        padding: '30px 0 0 0',
      },
      '.item_selected_container': {
        backgroundColor: '#f6f7ff',
        padding: '10px',
        borderRadius: '5px',
        '.item_selected': {
          display: 'flex',
          flexWrap: 'wrap',
          margin: '5px 0px 5px 0px',
        },
      },
      '.showCard': {
        width: 'auto',
        borderRadius: '10px !important',
        borderBottom: '5px !important',
        margin: '20px',
        '.cardHeader': {
          display: 'flex',
          backgroundColor: '#F9F9FD',
          alignItems: 'center',
          '.MuiTypography-root': {
            marginBottom: 0,
            display: 'flex',
          },
        },
        '.cardContent': {
          width: '100%',
          height: '100%',
          display: 'flex',
        },
        '.cardContentCompleteSide': {
          width: '100%',
          height: 'auto',
        },
        '.cardContentLeftSide': {
          flex: 1,
          padding: '10px 0 10px 15px',
        },
        '.cardContentRigthSide': {
          flex: 1,
          padding: '10px 15px 10px 0',
        },
      },
      '.divider_and_button_container': {
        width: '100%',
        height: '60px',
        margin: '20px 0 20px 0',
        display: 'flex',
        '.divider_and_button_container_button': {
          width: '3%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
        },
        '.divider_and_button_container_divider': {
          width: '97%',
          height: '30px',
        },
      },
      '.row_show_container': {
        width: '100%',
        height: 'auto',
        padding: '15px',
        '.row_show_header': {
          display: 'flex',
          alignItems: 'center',
        },
        '.row_show_content': {
          padding: '5px 0px 5px 0px',
          display: 'flex',
          flexWrap: 'wrap',
        },
      },
      '.accordion_summary_container': {
        width: '100%',
        height: 'auto',
        '.accordion_summary_column': {
          flex: 2,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          '.accordion_summary_column_absolute': {
            position: 'absolute',
            marginLeft: 'auto',
            marginRight: 'auto',
            left: 0,
            right: 0,
            top: 5,
            textAlign: 'center',
          },
          '.accordion_summary_column_red': {
            textAlign: 'center',
            backgroundColor: 'red',
            color: 'white',
            borderRadius: '10px',
            padding: '2px 5px 2px 5px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        },
      },
      '.accordion_details_scale': {
        width: '100%',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        '.number_scale': {
          color: 'rgb(14, 171, 190)',
          fontWeight: 600,
          display: 'flex',
          width: '10%',
          justifyContent: 'center',
        },
      },
      '.accordion_details_scale_detail': {
        width: '100%',
        height: '150px',
        display: 'flex',
        justifyContent: 'flex-end',
        '.accordion_details_scale_detail_container': {
          width: '90%',
          height: '100%',
          display: 'flex',
          backgroundColor: 'white',
          borderRadius: '10px',
          '.accordion_details_scale_detail_segment_icon': {
            flex: 1,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-end',
            paddingTop: '10px',
          },
          '.accordion_details_scale_detail_segment': {
            flex: 8,
            margin: '0 5px 0 5px',
            '.airport_detail': {
              width: '100%',
              height: '50%',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-around',
              alignItems: 'center',
            },
            '.flight_detail': {
              width: '50%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            },
          },
        },
      },
      '.baggage_container': {
        display: 'flex',
        width: '100%',
        margin: '55px 0 15px 0',
        justifyContent: 'center',
        alignItems: 'center',
        '.baggage_luggage': {
          fontWeight: 600,
          color: 'rgb(14, 171, 190)',
          textAlign: 'center',
          flex: 1,
        },
        '.baggage_info': {
          display: 'flex',
          width: '100%',
          flexWrap: 'wrap',
          flex: 6,
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
      '.air_segment': {
        width: '130px',
        height: '30px',
        color: 'white',
        display: 'flex',
        backgroundColor: 'rgb(14, 171, 190)',
        justifyContent: 'space-around',
        alignItems: 'center',
        borderRadius: '0 20px 20px 0',
        margin: '10px 0 10px 0',
      },
      '.passenger_container': {
        width: '100%',
        height: 'auto',
        marginTop: 15,
        '.passenger_info': {
          display: 'flex',
          padding: '0px 5px 0px 5px',
          margin: '20px 0 20px 0',
          '.passenger_column': {
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
          },
        },
      },
      '.cancellation_container': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        marginBottom: 20,
        ':last-child': {
          marginBottom: 0,
        },
        '.cancellation_column': {
          display: 'flex',
          flex: 1,
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          flexDirection: 'column',
          '.cancellation_column_value': {
            border: ' 1px  solid lightgray',
            padding: '3px',
            borderRadius: '10px',
            color: 'red',
            fontWeight: 600,
            display: 'flex',
          },
        },
      },
      '.date_reserve_container': {
        display: 'flex',
        '.date_reserve_box': {
          display: 'flex',
          margin: '0 10px 0 10px',
          alignItems: 'center',
        },
        '.date_reserve_value': {
          border: ' 1px  solid lightgray',
          padding: '3px',
          borderRadius: '10px',
          marginLeft: '10px',
          fontWeight: 600,
          display: 'flex',
        },
      },
      '.accordion_details_scale_container_train': {
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        '.accordion_details_scale_container_train_details': {
          width: '90%',
          height: '100%',
          display: 'flex',
          backgroundColor: 'white',
          borderRadius: '10px',

          '.vertical_scale': {
            flex: 1,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: '10px',
          },
          '.column_details': {
            flex: 8,
            margin: '0 5px 0 5px',
            '&.small': {
              flex: '4 !important',
            },
            '.rigth': {
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            },
            '.left': {
              width: '100%',
              height: '33%',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
            },
            '.center': {
              width: '100%',
              height: '33%',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
            },
          },
        },
      },
      '.reservation_tabs': {
        '& .MuiTabs-root': {
          marginBottom: 0,
        },

        '& .billing_reservation': {
          '& .blue': {
            color: styles.colors.primary
          },

          '& .generated_invoices': {
            '& .cardContent': {
              display: 'block',

              '& .invoice_card': {
                '& .cardHeader': {
                  backgroundColor: '#7b61ff26',

                  '& .MuiTypography-root': {
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: styles.colors.primary,

                    '& .gray': {
                      color: styles.body.color,
                    },
                  },
                },

                '& .MuiGrid-container': {
                  justifyContent: 'space-between',
                },

                '& .fields': {
                  borderBottom: '1px solid lightgray',
                  paddingTop: 16,
                  paddingBottom: 16,

                  '&:first-of-type': {
                    paddingTop: 0,
                  },

                  '&:last-child': {
                    borderWidth: 0,
                    paddingBottom: 0,
                  },

                  '& .field': {
                    display: 'flex',
                    flexDirection: 'column',

                    '& .value': {
                      color: styles.colors.primary,
                      fontWeight: 500,
                    },
                  },
                },
              },
            },
          },

          '& .actions': {
            '& .MuiGrid-item': {
              display: 'flex',
              alignItems: 'center',
            },

            "& .buttons-column": {
              flexWrap: "wrap",

              "& .MuiButton-root": {
                flex: 1,
                margin: 2
              }
            }
          },
        },

        '& .payment_reservation': {
          '& .MuiCardContent-root:last-child': {
            paddingBottom: 0,
          },

          '& .collapsible-row': {
            padding: '0 50px',
            border: '1px solid #e6e6e6',

            '& .MuiCollapse-wrapperInner': {
              display: 'flex',
              padding: '13px 0',

              '& .field': {
                marginRight: 40,
              },
            },
          },
        },
      },
      '.MuiDialog-root': {
        '& .MuiDialogActions-root': {
          '& .MuiButton-root[disabled]': {
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
      },
      '.reservation-create': {
        '& .MuiTabs-root': {
          marginBottom: 0
        },

        '& .tab-panel': {
          padding: '6px 8px 20px'
        }
      },

      '.dialog-product': {
        '& .general-information': {
          '& .editInputsWrap': {
            minHeight: 0,
          },
        },

        '& .small-fields': {
          '& .editInputsWrap': {
            minHeight: 0,
          },
        },

        '& .button-field-container': {
          '& .MuiGrid-root': {
            display: 'flex',
          },

          '& .MuiButton-root': {
            height: 45,
            boxShadow: 'none',
            top: -5,

            '&:not(.Mui-disabled)': {
              backgroundColor: '#e7e7e7',
              color: 'gray',

              '&:hover': {
                backgroundColor: '#d7d7d7',
              },
            },
          },

          '&.room-people-container': {
            '& input': {
              textAlign: 'center',

              '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
            },
          },
        },

        '& .item-container': {
          display: 'flex',
          flexWrap: 'wrap',

          '&:not(:nth-last-of-type(8))': {
            '& .delete-item': {
              marginBottom: 12
            }
          },

          '& .delete-item': {
            display: 'flex',
            justifyContent: 'flex-end',
            paddingTop: 0,
            margin: '-20px 12px 0',
            paddingBottom: 15,
            borderBottom: '1px solid lightgray',
          },
        },

        '& .passenger-container': {
          display: 'flex',

          ':nth-last-of-type(2)': {
            '& .editInputsWrap': {
              minHeight: 0,
            },
          },
        },

        '& .tooltip': {
          fontSize: 14,
          color: '#5663c9d1',
          cursor: 'pointer',
          margin: '0 5px',
        },

        '.MuiTableCell-body': {
          '& .MuiTypography-root': {
            fontFamily: styles.body.fontFamilySecondary,
            fontSize: styles.table_cell.body_fontSize,
          },
        },
      },
      '.files-card': {
        "& .files-container": {
          display: "flex",
          flexWrap: "wrap",
          gap: 20,
          padding: "12px 28px 0 !important",

          "& .file": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
            maxWidth: 150,
            cursor: "pointer",

            "& .file-icon": {
              fontSize: 40,
              marginBottom: 5
            },

            "& .name": {
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textWrap: "nowrap"
            },

            "& .delete-icon": {
              position: "absolute",
              top: 0,
              right: 0,
              padding: 0,
              display: "none"
            },

            "&:hover .delete-icon": {
              display: "inline-block"
            }
          }
        }
      },
      '.donut_car': {
        background: 'transparent',
        display: 'block',
        width: '150px',
        height: '150px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        border: '15px solid #FF6188',
        borderTop: '15px solid #A9DC62',
        borderLeft: '15px solid #78DCDC',
        borderRight: '15px solid #FFD862',
        borderRadius: '100%',
      },
      'input[type=number]': {
        '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
          display: 'none'
        },
      },
      '.emit-button:not(.Mui-diabled)': {
        backgroundColor: '#05afbe'
      },
      '.select-array-input label': {
        backgroundColor: 'white',
        padding: '0 5px',

        "&[data-shrink=false]": {
          transform: 'translate(14px, 9px) scale(1)',
        }
      },
      '.MuiTableCell-paddingCheckbox': {
        width: '44px !important',
        padding: '0 12px !important'
      },
      '.html-form-control': {
        marginTop: 25,

        '.html-label': {
          transform: 'translate(0px, -25px) !important'
        },

        '.html-wrapper-class': {
          padding: '1rem',
          border: '1px solid #ccc',
          borderRadius: 4
        },

        '.html-editor-class': {
          padding: '1rem',
          border: '1px solid #ccc',
          borderRadius: 4,
          cursor: 'text',
          minHeight: 200
        },

        '.html-editor-class.disabled': {
          backgroundColor: 'rgba(128, 128, 128, 0.25)',
          cursor: 'not-allowed'
        },

        '.html-toolbar-class': {
          border: '1px solid #ccc',
          borderRadius: 4
        }
      },
      '.html-label': {
        fontSize: `${styles.body.fontSize}px !important`,
        fontWeight: '600 !important',

        '&:not(.Mui-disabled)': {
          color: styles.body.color,
        },
      },
      '.react-checkbox-tree': {
        '& .rct-collapse': {
          width: 29,
          paddingRight: 0
        },

        "& .rct-collapse-btn": {
          display: "flex",
          alignItems: "center"
        },

        '& label': {
          display: 'flex',
          padding: "2px 0",

          "& > *": {
            display: "flex",
            alignSelf: "center"
          }
        }
      },
      '.sale-invoice-modal': {
        '& .MuiDialogActions-root': {
          justifyContent: 'space-between'
        }
      },
      '.reservation-show-container': {
        '& .products-card': {
          '& .MuiCheckbox-root': {
            padding: 0
          }
        }
      },
      '.sort-field-container': {
        display: 'flex',
        flexDirection: 'column',
        marginTop: -5,
        marginLeft: 5,
        height: 45,
        justifyContent: 'space-between',

        '& .MuiButton-root': {
          height: 20,
          padding: 6
        }
      },
      '& .react-multi-carousel-list': {
        '& .react-multi-carousel-track': {
          padding: 0
        },

        '& .react-multiple-carousel__arrow': {
          backgroundColor: '#fff',
          padding: 4,
          margin: 0,
          minHeight: 30,
          minWidth: 30,
          boxShadow: '0px 0px 2px 0px gray',
          zIndex: 10,

          '&:hover': {
            opacity: '50%'
          },

          '&::before': {
            color: '#1449e4',
            fontSize: 13,
            fontWeight: 'bold'
          },

          '&.react-multiple-carousel__arrow--left': {
            left: '5px',

            '&::before': {
              right: '1px'
            }
          },

          '&.react-multiple-carousel__arrow--right': {
            right: '5px',

            '&::before': {
              left: '1px'
            }
          }
        },

        '& .react-multi-carousel-dot-list': {
          flexWrap: 'wrap'
        },

        '& .carousel-item': {
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: 16
        }
      },
      '.all-banners-container': {
        '& .MuiContainer-root': {
          padding: 0,

          '@media (max-width: 599px)': {
            padding: '0 10px'
          },

          '&:not(.MuiContainer-maxWidthSm):not(.MuiContainer-maxWidthMd)': {
            '@media (min-width: 1440px)': {
              maxWidth: 1440
            },

            '@media (min-width: 1580px)': {
              maxWidth: 1580
            }
          }
        },

        '& .banner-item img': {
          borderRadius: 16
        },

        '& .banner-image-section': {
          padding: '30px 0',
          backgroundColor: '#fff',

          '& .banner-single-image': {
            display: 'flex',
            marginBottom: 16,

            '& img': {
              flex: 1
            }
          }
        },

        '& .banner-slider-section': {
          padding: '30px 0',

          '& .carousel-item': {
            aspectRatio: '16/8',
            width: '100%',
            minHeight: 160,
            height: 'auto',

            '@media(min-width: 900px)': {
              minHeight: 180,
              aspectRatio: '16/3'
            }
          }
        },

        '& .banner-offers-section': {
          paddingBottom: 30,
          paddingTop: 30,

          '& .react-multi-carousel-track': {
            paddingBottom: '10px !important',

            '& .react-multi-carousel-item': {
              padding: '0 16px',

              '& .banner-offer': {
                position: 'relative',
                height: '100%'
              },

              '& .discount-label': {
                position: 'absolute',
                left: 0,
                top: 0,
                borderRadius: '0 0 8px 0',
                color: '#fff',
                backgroundColor: '#008000',
                padding: '4px 8px'
              },

              '& .name-offer': {
                display: 'block',
                lineHeight: 1.4,
                minHeight: 54,
                color: '#1449e4',
                textDecoration: 'none',
                fontSize: '1.2rem'
              },

              '& .priceTextSecondary': {
                fontSize: 14
              }
            }
          }
        },

        '& .banner-promotions-section': {
          backgroundColor: styles.body.backgroundAlt,
          paddingBottom: 30,
          paddingTop: 30,

          '& .react-multi-carousel-track': {
            paddingBottom: '10px !important',

            '& .react-multi-carousel-item': {
              padding: '0 16px',

              '& > .MuiPaper-root': {
                height: '100%'
              },

              '& .title-banner-promotions': {
                fontSize: '1.3em',
                color: '#1449e4'
              }
            }
          },
        },

        '& .banner-featured-section': {
          paddingBottom: 30,
          paddingTop: 30,

          '& .react-multi-carousel-track': {
            paddingBottom: '10px !important',

            '& .react-multi-carousel-item': {
              padding: '0 16px'
            }
          },
        }
      },
      '& .previewDowloadableImagesComponent': {
        backgroundColor: '#e0e3ef36',
        borderRadius: 5,
        width: '100%',
        padding: '10px',
        marginBottom: 45,
        '& .containerTitle': {
          paddingLeft: 5,
          marginBottom: 5,
          color: '#8b96c3',
        },
        '& .list': {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          width: '100%',
        },

        '& .list-item': {
          border: '1px solid #80808038',
          borderRadius: 3,
          width: '24%', /* Para 4 elementos por fila */
          marginBottom: '20px',
          padding: '10px',
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          marginRight: '1%',
        },
        '& .list-item:nth-child(4n)': {
          marginRight: '0',
        },
        '& .imageContainer': {
          width: '100%', /* Para ocupar todo el ancho del .list-item */
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1, /* Para que crezca y tenga la misma altura que los demás */
          backgroundColor: 'white',
          borderRadius: 4,
          padding: 5,
          border: '1px solid #80808038',
        },

        '& .image': {
          width: '100%',
          height: '100%', /* Ocupará toda la altura disponible */
          objectFit: 'contain', /* Asegura que la imagen no se deforme */
        },

        '& .titleContainer': {
          marginBottom: '5px',
          '& .fileName': {
            fontSize: '11px',
            fontWeight: 'normal',
          },
          '& .title': {
            fontSize: '12px',
            fontWeight: 'bold',
            marginBottom: '-5px',
          },
        },

        '& .downloadButton': {
          fontSize: '14px',
          marginTop: '10px', /* Agrega espacio entre la imagen y el botón */
          textAlign: 'center',
        }
      },

      '& .dialog-message': {
        '& .MuiDialogTitle-root': {
          fontSize: '1.2rem'
        }
      },
      '& .preview-landing-modal': {
        '& img': {
          maxWidth: '100%'
        }
      },
      '& .se-container': {
        '& #custom-color-picker': {
          '& label': {
            display: 'flex',
            marginTop: 2,
            justifyContent: 'space-between',

            '& .preview-data': {
              fontSize: 12,
              marginTop: 3,
              color: '#acacac'
            }
          }
        },
        '& .se-image-container, & .se-image-container img': {
          margin: '0px !important',
          padding: '0px !important',
          outline: 'none !important',
          '&.__se__float-none figure': {
            margin: 'auto !important'
          }
        },
        '& .se-wrapper': {
          '& button': {
            pointerEvents: 'none'
          }
        }
      },
      '& .sun-editor-editable': {
        fontSize: 'inherit',
        fontFamily: 'inherit',

        '& a': {
          textDecoration: 'none !important'
        }
      },
      '& .element-button': {
        '& .MuiDivider-root': {
          marginLeft: 5,
          borderColor: '#0000004d'
        },

        '&.MuiLoadingButton-loading': {
          '& .MuiDivider-root': {
            borderColor: 'unset'
          }
        }
      },
      // Container CurrencyBase Relation
      '& .containerCurrencyBaseRelation': {
        borderBottom: '2px solid rgb(130 140 211)',
        backgroundColor: '#ffffff',
        marginBottom: 25,
        borderRadius: 3,
        padding: '10px 10px 30px 0px',
        '&.editing': {
          border: '2px solid #d32f2f45'
        },
      },
      // Boton Alerta media
      '.btnWarming': {
        '&.MuiButtonBase-root': {
          backgroundColor: styles.buttons.warning,
          '&:hover': {
            backgroundColor: styles.buttons.warning_hover,
          },
        },
      },
      // General Form Styles
      '& .generalFormStyles': {
        '& .MuiFormControl-root': {
          marginBottom: 25,
        },
        '& .tableInfoPayment': {
          marginBottom: '30px',
          borderCollapse: 'collapse',
          // width: '100%',
          '& .tableHead': {
            backgroundColor: '#f2f2f2',
          },
          '& .cell': {
            padding: 10,
            textAlign: 'left',
          },
          '& .bold': {
            fontWeight: 'bold',
          },
          '& .btn': {
            cursor: 'pointer',
            color: 'blue',
            textDecoration: 'underline',
          },
        },
      },
      // General table column info
      '& .tableInfoConfimation': {
        width: '100%',
        tableLayout: 'fixed',
        borderCollapse: 'collapse', // Para eliminar bordes dobles
        '& .cell': {
          textAlign: 'left',
          border: '1px solid #ddd', // Borde en cada celda
          padding: '8px',
          '&.bold': {
            fontWeight: 'bold'
          },
        },
        '& .tableHead': {
          '& .cell': {
            color: styles.text_colors.text_regular_light_grey,
            fontSize: '14px',
            fontWeight: 'normal',
            paddingBottom: 10,
            backgroundColor: '#f1f1f1',
            textAlign: 'center',
          },
        },
        '& .tableBody': {
          '& .cell': {
            color: styles.text_colors.text_regular_grey,
            fontSize: '14px',
          },
        },
      },
      '& .tableInfo': {
        width: '100%',
        tableLayout: 'fixed',
        borderCollapse: 'collapse',
        '&.bordered': {
          border: '1px solid',
          borderColor: styles.dialog.border_content_blue,
          borderRadius: 5,
        },
        '& .cell': {
          textAlign: 'left',
          padding: '5px 15px',
          '&.bold': {
            fontWeight: 'bold'
          },
        },
        '& .tableHead': {
          '& .cell': {
            color: styles.text_colors.text_regular_light_grey,
            // fontSize: '14px',
            fontWeight: 'normal',
            backgroundColor: '#f2f2f2',
            padding: 15,
          },
        },
        '& .tableBody': {
          '& .cell': {
            color: styles.text_colors.text_regular_grey,
            fontSize: '16px',
            padding: '5px 15px',
            '&.smallText': {
              fontSize: '15px',
            },
          },
          '& .lineTop': {
            color: '#5f759f',
            display: 'block',
            fontSize: '15px',
          },
          '& .lineBottom': {
            color: styles.text_colors.text_regular_light_grey,
            display: 'block',
            fontSize: '14px',
            marginBottom: 10,
            borderTop: '1px dashed #e5e5e5',
          },
        },
        '& .cell.cellTotalInfo': {
          borderTop: '2px solid',
          borderColor: styles.borders.border_blue_grey,
          borderTopStyle: 'dashed',
          color: styles.text_colors.text_label_blue,
        },
      },

      // General Dialog Container
      '& .generalDialogContainer': {
        color: styles.text_colors.text_regular_grey,

        '& .MuiPaper-rounded': {
          borderRadius: 8,
        },
        '& .dialogContent': {
          borderBottomColor: styles.dialog.border_content_blue,
          borderTopColor: styles.dialog.border_content_blue,
          marginTop: 15,
          '& .subtitleMessage': {
            fontWeight: 600,
            fontSize: '22px',
            color: '#FF9800',
            textAlign: 'center',
            marginBottom: 25,
            '& .icon': {
              fontSize: '29px',
              verticalAlign: 'sub'
            },
          },
          '& .borderMessage': {
            border: '2px solid #fe992a4a',
            padding: '15px 20px',
            borderRadius: 5,
          },
          '&.smallNotification': {
            padding: '50px 60px',
          },
        },
        '& .dialogTitle': {
          textAlign: 'left',
          color: styles.dialog.text_title_blue,
          padding: '10px 15px 5px',
          fontWeight: 500,
          fontSize: '18px',
          borderRadius: 5,
          '&.success': {
            color: styles.colors.success_hard,
          },
          '&.warning': {
            color: styles.colors.warning_hard,
          },
        },
        '& .dialogActions': {
          padding: '10px 15px',
        },
      },
      // Dialog Info To Confirm
      '& .dialogInfoToConfirm': {
        color: styles.text_colors.text_regular_grey,
        '& .dialogContent': {
          padding: '10px 25px 35px',
        },
        '& .MuiPaper-root': {
          borderRadius: 10,
        },
        // two column info
        '& .dataInfo': {
          display: 'flex',
          marginBottom: 5,
          '& .column': {
            marginRight: 10,
            color: styles.text_colors.text_regular_grey,
          },
          '& .left': {
            color: styles.text_colors.text_regular_light_grey,
            fontSize: '14px',
            width: '150px',
            '&.bigger': {
              fontSize: '16px',
            },
          },
          '& .right': {
            color: styles.text_colors.text_regular_grey,
            fontSize: '16px',
            '&.bigger': {
              fontSize: '18px',
            },
          },
        },

        '& .scrollingContainer': {
          maxHeight: '500px',
          width: '100%',
          overflow: 'auto'
        },
        '& .submitMessagesFeedback': {
          textAlign: 'center',
          '& .title': {
            color: styles.colors.success_hard,
            fontWeight: 600,
            fontSize: '22px',
            marginBottom: 20,
            '& .icon': {
              fontSize: '40px',
              verticalAlign: 'middle'
            },
          },
          '& .message': {
            border: '2px solid',
            borderColor: styles.colors.success_soft,
            color: styles.text_colors.text_regular_grey,
            padding: '30px 15px',
            borderRadius: 5,
          },

        },
        '& .submitMessagesFeedbackFail': {
          textAlign: 'center',
          '& .title': {
            color: styles.colors.warning_hard,
            fontWeight: 600,
            fontSize: '22px',
            marginBottom: 20,
            '& .icon': {
              fontSize: '40px',
              verticalAlign: 'middle'
            },
          },
          '& .message': {
            border: '2px solid',
            borderColor: styles.colors.warning_soft,
            color: styles.text_colors.text_regular_grey,
            padding: '30px 15px',
            borderRadius: 5,

          },

        },
        '& .imagesThumbnails': {
          '& .image': {
            width: '100%',
            height: '120px',
            border: '1px solid #d1d1d1',
            borderRadius: '4px',
            padding: '5px',
            objectFit: 'contain',
          },
          '& .text': {
            maxWidth: '100%',
            fontSize: '12px',
            position: 'relative',
            top: '-5px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            color: styles.text_colors.text_regular_light_grey,
          },
        },
      },
      // General Component Select
      "& .generalComponentSelect": {
        textAlign: 'left',
        "& .selectOptionDisabled": {
          color: styles.text_colors.text_regular_light_grey,
        },
        "& .MuiFormHelperText-root": {
          position: 'absolute',
          bottom: '-25px'
        },
      },
      // Component Upload File
      "& .componentUploadFileInput": {
        display: "flex",

        "& .errorMessage": {
          color: "#d14242",
          fontSize: 11,
        },
        "& .MuiFormControl-root": {
          paddingBottom: 0,
          marginBottom: 5,
        },
        "& .MuiButton-root": {
          height: 40,
          marginTop: 21,
          marginRight: 5,
        },
        "& .divButton": {
          "& .input": {
            display: "none"
          },
          display: "inline-block"
        },
        "& .bloqFileName": {
          flexGrow: 1,
          "& .MuiFormLabel-root": {
            marginTop: -10,
            color: styles.colors.primary,
          },
          "& .MuiInputBase-root.Mui-disabled": {
            backgroundColor: "rgb(247 247 247)"
          },
        },
      },
      // Conciliation Extract Container
      '.conciliationExtractContainer': {
        width: '80%',
        textAlign: 'center',
        margin: '0 auto',
        '& .message': {
          textAlign: 'center',
          color: styles.text_colors.text_regular_grey,
          marginBottom: 10
        },
        '& .container': {
          borderRadius: 10,
          border: '1px solid',
          borderColor: styles.borders.border_blue_grey,
          padding: '35px 25px'
        },
        '& .downloadButton': {
          borderColor: styles.borders.border_blue_grey,
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          paddingBottom: 2
        },
      },
      // Billing Form
      ".cobranzasStatusMessage": {
        border: '1px solid',
        borderColor: styles.borders.border_blue_grey,
        color: styles.text_colors.text_title_blue_grey,
        borderRadius: 5,
        fontSize: 13,
        padding: 10,
        borderStyle: 'dashed',
        backgroundColor: '#fdfdff'
      },
      // Conciliation View Container
      '.pageConciliationViewContainer': {
        "& .sendButton": {
          display: 'flex',
          alignItems: 'flex-end',
          paddingBottom: 7
        },
      },
      // General View
      '.pageGeneralContainer': {
        '& .pageCard': {
          backgroundColor: 'white',
          borderRadius: 10,
          boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.2)',
          border: '1px solid #dfdfdf',
          marginTop: 15,
          padding: '35px 25px'
        },
        "& .inputlabel": {
          textAlign: "left",
          fontSize: 14,
          marginLeft: 5,
          color: styles.text_colors.text_label_blue
        },
        "& .MuiFormHelperText-root": {
          position: 'absolute'
        },

        "& .headerButtons": {
          textAlign: 'center',
          marginBottom: 30,
          "& .selected": {
            backgroundColor: 'red'
          }
        }
      },
      // List View
      '.pageListContainer': {
        '& .billingFormListTable': {
          borderRadius: 10,
          border: '2px solid #c7c7c7',
          marginTop: 25,
          '& .MuiTableCell-root': {
            color: styles.body.color,
          },
          '& .tableHeader': {
            '& .MuiTableCell-root': {
              fontWeight: 600
            },
          },
          '& .bloqPagination': {
            borderTop: '1px solid #dfdfdf',
            marginTop: 15,
            padding: '10px 5px',
            '& .paginationPages': {
              fontSize: 14,
              marginRight: 15,
              color: styles.body.textRegularLightGrey,
              marginBottom: 4,
            },
          },
        },
        '& .pageListCard': {
          backgroundColor: 'white',
          borderRadius: 10,
          boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.2)',
          border: '1px solid #dfdfdf',
          marginTop: 15,
          padding: '35px 25px'
        },

        '& .listElementDetailButton': {
          border: '1px solid green',
          color: styles.body.textRegularLightGrey,
          fontFamily: "'Roboto', sans-serif",
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          margin: '0px 15px',
          '& .element': {
            border: '1px solid pink',
            flexGrow: 1,
          },
          '&:hover': {
            '& .element': {
              color: 'grey',
            },
          },
          '& .title': {
            fontWeight: 'bold',
            textTransform: 'uppercase',
          },
          '& .button': {
            textAlign: 'right'

          },
        },
        '& .filterContainer': {
          border: '2px solid #5563CD',
          borderRadius: 10,
          '& .editInputsWrap ': {
            minHeight: 'auto',
            '& .labelBloq': {
              margin: '5px 6px',
              '& .MuiFormLabel-root': {
                color: '#5f5f5f',
                fontWeight: 400,
              },
            },
            '& .MuiInputBase-input': {
              height: 18,
            },
            '& .MuiSelect-select': {
              padding: '6px 15px'
            },
          },
          '& .titleFilter': {
            backgroundColor: '#ffffff',
            top: '-15px',
            position: 'absolute',
            padding: '0px 5px',
            color: '#5563CD',
            fontWeight: 600,
            '& .text': {
              verticalAlign: 'super'
            },
            '& .icon': {
              width: 18,
              position: 'relative',
              left: '-5px',
            },
          },
          '& .filterHeader': {
            minHeight: 15,
            '& .Mui-expanded': {
              margin: 0
            },
          },
          '& .filterBody': {
            padding: '5px 18px 20px',
            '& .btnFilter': {
              marginTop: 25,
              marginBottom: 5
            }
          }
        },
      },
      '& .installment-extra-data-container': {
        backgroundColor: '#e5e5ea',
        borderRadius: 8,
        paddingTop: '27px !important',

        '& input, & .MuiSvgIcon-root, & .MuiSelect-select': {
          zIndex: 1
        },

        '& fieldset': {
          backgroundColor: '#fff'
        }
      },
      '& .installment-extra-data-container-show': {
        backgroundColor: '#e5e5ea',
        borderRadius: 8,
        paddingTop: '0px !important'
      },
      '& .baggage-container-icons': {
        '& svg': {
          color: '#7cbe4c',

          '&:not(:last-of-type)': {
            marginRight: 10
          },

          '&.not-included': {
            color: '#bdbdbd'
          }
        }
      },
      '& .baggage-container': {
        padding: '8px 0px',

        '&  > .MuiGrid-root': {
          '&:not(:last-of-type)': {
            marginBottom: 5
          },

          '& .icon-container': {
            textAlign: 'center',
          },

          '& .baggage-description': {
            display: 'flex',
            flexDirection: 'column'
          }
        },

        '& svg': {
          color: '#7cbe4c',

          '&.not-included': {
            color: '#bdbdbd'
          }
        }
      },
      '& .import-installment-modal': {
        "& .file": {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          maxWidth: 150,
          cursor: "pointer",

          "& .file-icon": {
            fontSize: 40,
            marginBottom: 5
          },

          "& .name": {
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textWrap: "nowrap"
          },

          "& .delete-icon": {
            position: "absolute",
            top: 0,
            right: 0,
            padding: 0,
            display: "none"
          },

          "&:hover .delete-icon": {
            display: "inline-block"
          }
        }
      }
    }}
  />
)

export default AppGlobalStyles
